export { ResourceLinksModal } from "./resource-links-modal";
